module.exports = __webpack_public_path__ + "content/dam/oppo/coloros/img/photography-wideAngle.61019a0f.jpg";